import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useNavigate } from "react-router-dom";
import { customerListAction } from "../../redux/actions/general-action";
import { useDispatch } from "react-redux";

import { salesPaymentInCusAction } from "../../redux/actions/sales-action";
import moment from "moment";
import errorToast from "../helper-components/error-toast";
import { purchasePaymentOutCusAction } from "../../redux/actions/purchase-action";
import ItemsInputField from "../forms/items-input-field";
import ItemsSearchAddFeild from "../forms/items-search-add-field";
import SearchField from "../forms/search-field";
import FilterRadioButtons from "../forms/custom-filter-radio-buttons";
import { paymentInSelect } from "../helper-components/data";
import RadioButton from "../forms/radio-button";
const inputClass =
  "min-h-[38.4px] px-2 border border-[var(--items-search-input-border)] focus:outline-none focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)] text-[var(--items-search-input-color)] text-[length:var(--items-search-input-font-size)] font-[var(---items-search-place-font-weight)] border-radius input-field-no-spin-buttons";

const labelClass =
  " font-[var(--search-label-font-weight)] pb-[3.2px]  text-[var(--items-search-input-label-color)] ";
const PaymentInOutHeader = ({
  page,
  disabled,
  searchRef = {},
  clearDue,
  setClearDue,
  setCheckedId,
  section = "pit",
}) => {
  const today = new Date();
  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  const navigate = useNavigate();
  const { errors, values, setFieldValue, initialValues, setFieldError } =
    useFormikContext();
  const loadOptions = (inputValue, field) => {
    return new Promise((resolve) => {
      const isCustomer = values.is_customer ?? true;
      const newLabel = isCustomer ? "+ New Customer" : "+ New Vendor";

      const fallbackOption = {
        value: "new_customer",
        label: <span className="text-primary">{newLabel}</span>,
      };

      const onSuccess = (data) => {
        const options = [
          ...data.data.map((item) => ({
            value: item.cmr_id,
            label:
              item?.cmr_code +
              "-" +
              (item?.cmr_first_name + item?.cmr_last_name),
          })),

          fallbackOption,
        ];
        setLocalData(data.data);
        resolve(options);
      };

      const onError = (error) => {
        resolve([fallbackOption]);
      };

      if (inputValue?.length > 0) {
        dispatch(
          customerListAction(
            {
              field: field,
              value: inputValue,
              isVendor: !values.is_customer,
            },
            onSuccess,
            onError
          )
        );
      } else {
        resolve([fallbackOption]);
      }
    });
  };

  function fetchPayFn(field, value) {
    let actionType = salesPaymentInCusAction;
    if (section === "pot") {
      actionType = purchasePaymentOutCusAction;
    }
    dispatch(
      actionType(
        {
          field: field,
          value: value,
        },
        onSuccess,
        onError
      )
    );
  }
  const onSuccess = (data) => {
    const prefix = section === "pit" ? "soit" : "poit";

    setFieldValue(
      "invoices",
      data?.data?.getInvoiceResult?.map((item) => {
        const startDate = new Date(item?.[`${prefix}_delivery_date`]);
        const endDate = new Date(today);
        const differenceInTime = endDate.getTime() - startDate.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return {
          id: item?.[`${prefix}_id`],
          [`${prefix}_invoice_number`]: item?.[`${prefix}_invoice_number`],

          ...(section !== "pit" && { podt_doc_type: item?.podt_doc_type }),
          ...(section === "pit" && { pdt_doc_type: item?.pdt_doc_type }),
          // [`${prefix}_Doc`]:
          //   section === "pit" ? "Sales Invoice" : "Purchase Invoice",
          [`${prefix}_document_date`]: moment(
            item?.[`${prefix}_document_date`]
          ).format("YYYY-MM-DD"),
          [`${prefix}_delivery_date`]: moment(
            item?.[`${prefix}_delivery_date`]
          ).format("YYYY-MM-DD"),
          [`${prefix}_due_days`]: parseInt(differenceInDays),
          [`${prefix}_total_amount`]: item?.[`${prefix}_total_amount`],
          [`${prefix}_total_payment`]: item?.[`${prefix}_due_amount`] ?? 0,
          [`${prefix}_due_amount`]: item?.[`${prefix}_due_amount`] ?? 0,
          [`${prefix}_status`]: item?.[`${prefix}_payment_status`] ?? "-",
        };
      }) ?? []
    );

    setFieldValue(
      `${section}_open_balance`,
      data?.data?.cmrOpenBalance?.cmr_open_balance ?? 0
    );
    if (data?.data?.cmrOpenBalance?.cmr_open_balance > 0) {
      setFieldValue(
        "clearDueInput",
        data?.data?.cmrOpenBalance?.cmr_open_balance ?? 0
      );
    }
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };
  const handelUserChange = (e) => {
    const value = e.target.value === "true";
    if (value !== values.is_customer) {
      setFieldValue("is_customer", value);
      setFieldValue("cmr_code", "");
      setFieldValue("cmr_name", "");
      setFieldValue("cmr_id", "");
      setFieldValue("invoices", initialValues?.invoices);
    }
    if (value && section === "pot") setClearDue(true);
    else if (!value && section === "pit") setClearDue(true);
    else setClearDue(false);
  };

  function clearAll() {
    setFieldValue("paymentModeData", initialValues?.paymentModeData);
    setFieldValue("cmr_code", "");
    setFieldValue("cmr_name", "");
    setFieldValue("invoices", initialValues?.invoices);
    setFieldValue("credit_note_amount", 0);
    setFieldValue("journal_entry", 0);
    setFieldValue(`${section}_open_balance`, 0);
    setFieldValue(`${section}_current_payment`, 0);
    setFieldValue("fixedCurrentPayment", 0);
    setFieldValue("clearDueInput", 0);
    setCheckedId([]);
  }
  useEffect(() => {
    if (page === "add") clearAll();
  }, [values.is_customer]);
  return (
    <div className="my-[1.125rem] mx-[24px] flex items-center ">
      <div className=" justify-between bg-[var(--add-billing-head-bg)] rounded-[8px] border border-[var(--create-table-main-border)] h-[87px] flex items-center p-[14px] w-full ">
        <div className="w-full flex  justify-between  ">
          {console.log("...", values)}
          <FilterRadioButtons
            inputClass=" w-[1.32856rem] h-[1.32856rem] "
            valueclass="flex gap-[1.5rem] items-center"
            name="select one"
            label={"Select One"}
            disabled={disabled}
            options={paymentInSelect}
            className=" flex flex-col justify-between"
            handleChange={handelUserChange}
            value={values.is_customer}
          />

          <div className=" flex flex-row gap-3 ">
            <SearchField
              className="font-[var(--search-place-font-weight)]"
              isLabelReq="true"
              labelClass="flex gap-1 mt-auto   text-[var(--search-input-label-color)]  text-[length:--search-label-font-size] font-[var(--search-label-font-weight)]"
              errorClass="hidden"
              disabled={disabled}
              marginRight=""
              minWidth="14rem"
              cusType={values.is_customer ? "Customer" : "Vendor"}
              type="text"
              label="Customer / Vendor Code"
              name={"cmr_code"}
              placeholder="Enter Customer / Vendor Code"
              onCreateOption={() => {}}
              loadOptions={(e) => loadOptions(e, "cmr_code")}
              onChange={(selectedOption, actionMeta) => {
                if (actionMeta?.action === "clear") {
                  clearAll();
                } else if (
                  selectedOption === "new_customer" ||
                  selectedOption?.value === "new_customer"
                ) {
                  navigate("/add-customer");
                } else {
                  const customerData = localData?.find(
                    (item) => item?.cmr_id === selectedOption?.value
                  );

                  fetchPayFn("cmr_id", customerData?.cmr_id);
                  setFieldValue("cmr_code", {
                    label: customerData?.cmr_code,
                    value: customerData?.cmr_id,
                  });
                  setFieldValue("cmr_id", customerData?.cmr_id);
                  setFieldValue("cmr_name", {
                    value: customerData?.cmr_id,
                    label:
                      customerData?.cmr_first_name +
                      " " +
                      customerData?.cmr_last_name,
                  });

                  if (searchRef && searchRef.current) {
                    searchRef.current.focus();
                    setFieldError("cmr_name", "");
                  }
                }
              }}
            />
            <SearchField
              isLabelReq="true"
              labelClass="flex gap-1 mt-auto whitespace-nowrap text-[var(--search-input-label-color)]  text-[length:--search-label-font-size] font-[var(--search-label-font-weight)]"
              errorClass="hidden"
              disabled={disabled}
              minWidth="14rem"
              marginRight=""
              cusType={values.is_customer ? "Customer" : "Vendor"}
              type="text"
              label="Customer / Vendor Name"
              autoFocus={true}
              name={"cmr_name"}
              placeholder="Enter Customer / Vendor Name"
              onCreateOption={() => {}}
              loadOptions={(e) => loadOptions(e, "cmr_first_name")}
              onChange={(selectedOption, actionMeta) => {
                if (actionMeta?.action === "clear") {
                  clearAll();
                } else if (
                  selectedOption === "new_customer" ||
                  selectedOption?.value === "new_customer"
                ) {
                  navigate("/add-customer");
                } else {
                  const customerData = localData?.find(
                    (item) => item?.cmr_id === selectedOption?.value
                  );
                  fetchPayFn("cmr_id", customerData?.cmr_id);
                  setFieldValue("cmr_code", {
                    label: customerData?.cmr_code,
                    value: customerData?.cmr_id,
                  });
                  setFieldValue("cmr_id", customerData?.cmr_id);
                  setFieldValue("cmr_name", {
                    value: customerData?.cmr_id,
                    label:
                      customerData?.cmr_first_name +
                      " " +
                      customerData?.cmr_last_name,
                  });
                  if (searchRef && searchRef.current) {
                    setTimeout(() => {
                      searchRef.current.focus();
                      setFieldError("cmr_name", "");
                    }, 0);
                  }
                }
              }}
            />
          </div>
          <div className="flex flex-row  gap-2">
            <div className="flex flex-col  gap-3">
              <ItemsInputField
                inputClass={inputClass}
                labelClass={labelClass}
                disabled={disabled}
                type="date"
                name={`${section}_due_date`}
                label="Due Date"
                isLabelReq="true"
              />
            </div>
            <div className="flex flex-col gap-1">
              <ItemsInputField
                inputClass={inputClass}
                labelClass={labelClass}
                disabled={disabled}
                errMsgContainerClass="hidden"
                type="date"
                name={`${section}_doc_date`}
                label="Doc Date"
                isLabelReq="true"
              />
            </div>
            <div className="flex flex-col gap-1">
              <ItemsInputField
                inputClass={inputClass}
                labelClass={labelClass}
                containerClass=""
                disabled={disabled}
                errMsgContainerClass="hidden"
                type="date"
                name={`${section}_posting_date`}
                label="Posting Date"
                isLabelReq="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInOutHeader;
